export default class AdiaLive5Error{
    //static LocalMediaStart = 11;

    constructor(errorCode, exception, errorData){
        //const LocalMediaStartErr = 11;

        this.errorCode = errorCode;
        this.exception = exception;

        this.name = 'UnknownError';
        this.message = 'Unknown Error';

        if(10 <= errorCode && errorCode <= 19){
            this.name = 'LocalMediaError';

            switch (errorCode) {
                case 11:
                    this.message = 'Error starting local media';

                    if(exception && exception.name === 'NotFoundError'){
                        this.errorCode = 111;
                        this.message = 'Can not find camera / mic'
                    }
                    else if(exception && exception.name === 'NotAllowedError'){
                        this.errorCode = 112;
                        this.message = 'Camera / mic access not allowed'
                    }
                    else if(exception && exception.name === 'NotReadableError'){
                        this.errorCode = 113;
                        this.message = 'Camera / mic is already in use'
                    }
                    else if(exception && exception.name === 'OverconstrainedError'){
                        this.errorCode = 114;
                        this.message = 'Overconstrained: ' + exception.constraint;
                    }

                    break;

                case 12:
                    this.message = 'Error starting screenshare';

                    if(exception && exception.name === 'NotAllowedError'){
                        this.errorCode = 121;
                        this.message = 'Screenshare access not allowed'
                    }

                    break;

                case 13:
                    this.message = 'Error getting devices';

                    if(exception && exception.name === 'NotAllowedError'){
                        this.errorCode = 131;
                        this.message = 'Permission denied'
                    }

                    break;

                case 14:
                    this.message = 'Error stopping local media';
                    break;

                case 15:
                    this.message = 'Error stopping screenshare';
                    break;

                case 16:
                    this.message = 'Error changing audio device';

                    if(exception && exception.name === 'NotFoundError'){
                        this.errorCode = 161;
                        this.message = 'Can not find microphone'
                    }
                    else if(exception && exception.name === 'NotReadableError'){
                        this.errorCode = 162;
                        this.message = 'Microphone is already in use'
                    }

                    break;

                case 17:
                    this.message = 'Error changing video device';

                    if(exception && exception.name === 'NotFoundError'){
                        this.errorCode = 171;
                        this.message = 'Can not find camera'
                    }
                    else if(exception && exception.name === 'NotReadableError'){
                        this.errorCode = 172;
                        this.message = 'Camera is already in use'
                    }

                    break;
            }
        }
        else if(20 <= errorCode && errorCode <= 29){
            this.name = 'ConnectionError';

            switch (errorCode) {
                case 21:
                    this.message = 'Registration failed';

                    if(exception && exception.name === 'timeout'){
                        this.errorCode = 211;
                        this.message = 'Timeout trying to connect to server'
                    }

                    break;

                case 22:
                    this.message = 'Local connection failed';
                    break;

                case 23:
                    this.message = 'Remote connection failed';
                    break;

                case 24:
                    this.message = 'Channel does not exist';
                    break;

                case 25:
                    this.message = 'Error trying to leave';
                    break;

                case 26:
                    this.message = 'Could not stop screenshare';
                    break;
            }
        }
        else if(30 <= errorCode && errorCode <= 39){
            this.name = 'StatsCollectorError';

            switch (errorCode) {
                case 31:
                    this.message = 'Error getting stats';
                    break;

            }
        }
        else if(40 <= errorCode && errorCode <= 49){
            this.name = 'ConfigError';

            switch (errorCode) {
                case 41:
                    this.message = 'Invalid mode set';
                    break;
            }
        }
        else if(50 <= errorCode && errorCode <= 59){
            this.name = 'BrowserCompatibilityError';

            switch (errorCode) {
                case 51:
                    this.message = 'WebRTC not supported';

                    if(errorData){
                    	this.errorData = errorData;
					}

                    break;

                case 52:
                    this.message = 'Media Recorder not supported';
            }
        }
        else if(60 <= errorCode && errorCode <= 69){
            this.name = 'RecorderError';

            switch(errorCode){
                case 61:
                    this.message = 'Error starting recorder';
                    break;

                case 62:
                    this.message = 'Error recording stream';

                    if(errorData){
                        this.message += ' - ' + errorData;
                    }
                    break;

                case 63:
                    this.message = 'Error updating meeting info';
                    break;
            }
        }
    }

    toString(){
        return this.name + ' ' + this.errorCode + ': ' + this.message + ' (' + this.exception + ') *';
    }
}

AdiaLive5Error.LocalMediaStart = 11;